import React from "react";
import cx from "classnames";
import { Theme, mapThemeToClassNames } from "ui/themes";
import { FB_APP_ID } from "lib/constants";

export function AmpPage(props: any) {
  const { theme, header, article, relatedArticles } = props;

  const className = cx({
    page: true,
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    [mapThemeToClassNames[theme]]: true,
  });

  return (
    <main className={className}>
      <header className="page__header">{header}</header>

      <article className="page__article">{article}</article>

      <div className="page__share">
        <div className="share">
          <div className="share__item">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message */}
            <amp-social-share
              type="twitter"
              width="48"
              height="48"
              data-target="_blank"
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message
            ></amp-social-share>
          </div>
          <div className="share__item">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message */}
            <amp-social-share
              type="facebook"
              width="48"
              height="48"
              data-target="_blank"
              data-param-app_id={FB_APP_ID}
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message
            ></amp-social-share>
          </div>
          <div className="share__item">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message */}
            <amp-social-share
              type="pinterest"
              width="48"
              height="48"
              data-target="_blank"
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message
            ></amp-social-share>
          </div>
          <div className="share__item">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message */}
            <amp-social-share
              type="linkedin"
              width="48"
              height="48"
              data-target="_blank"
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'amp-social-share' does not exist on type... Remove this comment to see the full error message
            ></amp-social-share>
          </div>
        </div>
      </div>

      <div className="page__related-articles">{relatedArticles}</div>
    </main>
  );
}

AmpPage.Theme = Theme;

export default AmpPage;
